import React from "react";
import { Helmet } from "react-helmet-async";

import GlobalHero from "../components/global/GlobalHero";
import HomeAbout from "../components/global/HomeAbout";
import GlobalCta from "../components/global/GlobalCta";

import { aboutSections } from "../components/about/aboutSections";

import "../components/home/home.css";

const AboutUs = () => {
  const renderSection = (section, index) => {
    switch (section.type) {
      case "hero":
        return (
          <GlobalHero
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      case "about":
        return (
          <HomeAbout
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
            image={section.image}
            imageAlt={section.imageAlt}
            reverse={section.reverse}
            items={section.items}
            note={section.note}
            background={section.background}
            whatsappButton={section.whatsappButton}
            actions={section.actions}
          />
        );

      case "dark-section":
        return (
          <section key={index} className="service-areas container-fluid">
            <div className="container">
              <div
                className="border rounded p-5"
                data-aos="fade-up"
                data-aos-duration="1400"
                data-aos-easing="ease-out-cubic"
                data-aos-once="true"
              >
                <h2
                  className="h2-title light-title"
                  data-aos="fade-up"
                  data-aos-delay="200"
                  data-aos-duration="1400"
                  data-aos-once="true"
                >
                  {section.title}
                </h2>
                {section.paragraphs?.map((p, i) => (
                  <p key={i} className="text-light my-4">
                    {p}
                  </p>
                ))}
                {section.items?.length > 0 && (
                  <ul data-aos="fade-up" data-aos-delay="300" data-aos-duration="1400" data-aos-once="true">
                    {section.items.map((item, i) => (
                      <li key={i} className="text-light">
                        <strong>{item.title}: </strong>{item.description}
                      </li>
                    ))}
                  </ul>
                )}
                {section.note && (
                  <p className="text-light my-4">{section.note}</p>
                )}
              </div>
            </div>
          </section>
        );

      case "cta":
        return (
          <GlobalCta
            key={index}
            title={section.title}
            description={section.description}
            paragraphs={section.paragraphs}
          />
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Helmet>
        <title>About Chiller Fleet Transport | Refrigerated Transport Company in Dubai &amp; Sharjah</title>
        <meta name="description" content="Learn about Chiller Fleet Transport, a refrigerated transport company operating across Dubai and Sharjah handling cold chain logistics & fleet operations across the UAE." />
        <meta property="og:title" content="About Chiller Fleet Transport | Refrigerated Transport Company in Dubai & Sharjah" />
        <meta property="og:description" content="Learn about Chiller Fleet Transport, a refrigerated transport company operating across Dubai and Sharjah handling cold chain logistics & fleet operations across the UAE." />
        <link rel="canonical" href="https://chillerfleet.com/about-us" />
        <meta property="og:url" content="https://chillerfleet.com/about-us" />
        <meta name="twitter:title" content="About Chiller Fleet Transport | Refrigerated Transport Company in Dubai & Sharjah" />
        <meta name="twitter:description" content="Learn about Chiller Fleet Transport, a refrigerated transport company operating across Dubai and Sharjah handling cold chain logistics & fleet operations across the UAE." />
      </Helmet>

      {aboutSections.map(renderSection)}
    </>
  );
};

export default AboutUs;
